import { render, staticRenderFns } from "./cgil-vue-autocomplete-element-ui.vue?vue&type=template&id=519e9370&scoped=true&"
import script from "./cgil-vue-autocomplete-element-ui.vue?vue&type=script&lang=js&"
export * from "./cgil-vue-autocomplete-element-ui.vue?vue&type=script&lang=js&"
import style0 from "./cgil-vue-autocomplete-element-ui.vue?vue&type=style&index=0&id=519e9370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e9370",
  null
  
)

component.options.__file = "cgil-vue-autocomplete-element-ui.vue"
export default component.exports